import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";

export class SearchSuggestion {

    @JsonProperty({ type: 'true' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'SearchSuggestion' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    suggestion: string;

    @JsonProperty({ type: 'number' })
    score: number;

}



// WEBPACK FOOTER //
// ./src/api/src/models/search_suggestion.ts